export default "__VITE_ASSET__BPziKa2U__"